import React, { createContext, useContext, useState } from "react";

interface IReportPresentationContext {
  hiddenColumns: string[];
  setHiddenColumns: React.Dispatch<React.SetStateAction<string[]>>;

  groupBy: string[];
  setGroupBy: React.Dispatch<React.SetStateAction<string[]>>;
}

const ReportPresentationContext = createContext<IReportPresentationContext | undefined>(
  undefined,
);

export function ReportPresentationProvider({ children }: { children: React.ReactNode }) {
  const [hiddenColumns, setHiddenColumns] = useState<string[]>([]);
  const [groupBy, setGroupBy] = useState<string[]>([]);

  return (
    <ReportPresentationContext.Provider
      value={{
        hiddenColumns,
        setHiddenColumns,
        groupBy,
        setGroupBy,
      }}
    >
      {children}
    </ReportPresentationContext.Provider>
  );
}

export function useReportPresentation() {
  const context = useContext(ReportPresentationContext);

  if (!context) {
    throw new Error(
      "useReportPresentation must be used within ReportPresentationProvider",
    );
  }

  return context;
}

export function withReportPresentation(Component: React.ComponentType<any>) {
  return function ReportPresentationWrapper(props: any) {
    return (
      <ReportPresentationProvider>
        <Component {...props} />
      </ReportPresentationProvider>
    );
  };
}